<template>
  <DragDialog
    title="扩展属性"
    :width="800"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="closeDialog"
    class="inner-pop-primary">
    <div class="elem-info-box">
      <div class="item-box">
        <div class="label">构件id：</div>
        <div class="value">{{ elemInfo.elemId }}</div>
      </div>
      <div class="item-box elem-name-box">
        <div class="label">构件名称：</div>
        <div
          class="value text-overflow"
          :title="elemInfo.elemName">
          {{ elemInfo.elemName }}
        </div>
      </div>
      <div class="item-box">
        <div class="label">文件名称：</div>
        <div
          class="value text-overflow"
          :title="elemInfo.fileName">
          {{ elemInfo.fileName }}
        </div>
      </div>
    </div>
    <div class="extend-params-box">
      <div class="group-box">
        <div class="add-group-box">
          <el-button
            class="primary-btn"
            size="small"
            @click="addParamGroup"
            icon="el-icon-plus">
            添加属性分组
          </el-button>
        </div>
        <div class="group-list-box">
          <div
            v-for="(item, index) in paramGroupList"
            :key="index"
            class="item-box">
            <div
              class="edit-group-box"
              v-if="item.isEdit">
              <el-input
                size="small"
                class="input-primary"
                :value="item.extendParamGroupName"
                placeholder="请输入属性分组名称"
                :max-length="100"
                @input="value => editGroupName(item, value)" />
              <div class="action-btn-box">
                <div
                  class="submit-btn-box icon-box"
                  @click.stop="saveGroupName(item)">
                  <i class="el-icon-check" />
                </div>
                <div
                  class="cancel-btn-box icon-box"
                  @click.stop="cancelEditGroupName(item)">
                  <i class="el-icon-close" />
                </div>
              </div>
            </div>
            <div
              v-else
              :class="`normal-group-box ${isGroupActive(item) ? 'active' : ''}`"
              @click="handleGroupClick(item)">
              <div class="group-name">{{ item.extendParamGroupName }}</div>
              <div class="action-btn-box">
                <div
                  class="icon-box"
                  title="重命名"
                  @click.stop="reNameGroup(item)">
                  <icon-svg icon-class="icon-zhongmingming" />
                </div>
                <div
                  class="icon-box"
                  title="删除"
                  @click.stop="deleteGroup(item)">
                  <icon-svg icon-class="icon-shanchu" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!paramGroupList.length"
          class="empty-box">
          <div class="tip-box">
            <!-- <div class="img-box">
              <img :src="require('@/assets/img/no-group.png')" />
            </div> -->
            <div class="text-btn-box">暂无分组</div>
          </div>
        </div>
      </div>
      <div class="split-line" />
      <div class="param-box">
        <el-button
          class="primary-btn"
          size="small"
          @click="addParam"
          :disabled="isAddParamDisabled()"
          icon="el-icon-plus">
          添加属性
        </el-button>
        <div
          class="table-box"
          v-if="paramsList.length">
          <el-table
            highlight-selection-row
            class="publish-table publish-small-table"
            :data="paramsList"
            height="100%">
            <el-table-column label="属性名称">
              <template v-slot="{ row }">
                <div v-if="row.isEdit">
                  <el-input
                    v-focus
                    size="small"
                    class="input-primary"
                    :value="row.extendParamName"
                    placeholder="请输入属性名称"
                    :max-length="100"
                    @input="val => editParam(row, 'extendParamName', val)" />
                </div>
                <div v-else>
                  {{ row.extendParamName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="属性值">
              <template v-slot="{ row }">
                <div v-if="row.isEdit">
                  <el-input
                    size="small"
                    class="input-primary"
                    :value="row.extendParamValue"
                    placeholder="请输入属性值"
                    :max-length="100"
                    @input="val => editParam(row, 'extendParamValue', val)" />
                </div>
                <div v-else>
                  {{ row.extendParamValue }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="单位">
              <template v-slot="{ row }">
                <div v-if="row.isEdit">
                  <el-input
                    size="small"
                    class="input-primary"
                    :value="row.extendParamType"
                    placeholder="请输入属性单位"
                    :max-length="100"
                    @input="val => editParam(row, 'extendParamType', val)" />
                </div>
                <div v-else>
                  {{ row.extendParamType }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="100">
              <template v-slot="{ row }">
                <div class="cell-operation-btn-box">
                  <el-button
                    v-if="row.isEdit"
                    type="text"
                    size="small"
                    @click="saveParam(row)">
                    保存
                  </el-button>
                  <el-button
                    v-if="row.isEdit"
                    type="text"
                    size="small"
                    @click="cancelEditParam(row)">
                    取消
                  </el-button>
                  <el-button
                    v-if="!row.isEdit"
                    type="text"
                    size="small"
                    @click="enableParamEdit(row)">
                    编辑
                  </el-button>
                  <el-button
                    v-if="!row.isEdit"
                    type="text"
                    size="small"
                    @click="deleteParam(row)">
                    删除
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          class="empty-box"
          v-else>
          <div class="tip-box">
            <div class="img-box">
              <img :src="require('@/assets/img/no-params.png')" />
            </div>
            <div class="text-btn-box">暂无属性</div>
          </div>
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import {
  createExtendParamGroupService,
  updateExtendParamGroupService,
  deleteExtendParamGroupService,
  getExtendParamGroupListService,
  getExtendParamsService,
  createExtendParamService,
  updateExtendParamService,
  deleteExtendParamByGroupService,
  deleteExtendParamByIdService
} from '@/service/interface'

export default {
  data() {
    return {
      paramGroupList: [],

      currSelectedGroupId: '',
      paramsList: []
    }
  },
  props: {
    visible: Boolean,
    elemInfo: Object,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initData()
      } else {
        this.clearData()
      }
    }
  },
  methods: {
    initData() {
      this.queryParamGroupRequest().then(() => {
        if (this.paramGroupList.length) {
          // prettier-ignore
          let extendParamGroupId = this.paramGroupList[0].extendParamGroupId;
          this.currSelectedGroupId = extendParamGroupId
          this.queryParamsRequest(extendParamGroupId)
        }
      })
    },
    addParamGroup() {
      let isExistEditingGroup = this.paramGroupList.some(el => el.isEdit)
      if (isExistEditingGroup) {
        this.$message.warning('请先保存当前正在编辑的属性分组')
        return
      }

      let isExistEditingParam = this.paramsList.some(el => el.isEdit)
      if (isExistEditingParam) {
        this.$message.warning('请先保存当前正在编辑的属性')
        return
      }

      this.currSelectedGroupId = ''
      let tempGroup = {
        extendParamGroupId: -1,
        extendParamGroupName: '',
        isNewAdd: true,
        isEdit: true
      }
      this.paramGroupList.push(tempGroup)
    },
    editGroupName(groupInfo, value) {
      this.$set(groupInfo, 'extendParamGroupName', value)
    },
    saveGroupName(groupInfo) {
      if (groupInfo.isNewAdd) {
        this.createParamGroupRequest(groupInfo).then(extendParamGroupId => {
          this.currSelectedGroupId = extendParamGroupId
          this.queryParamGroupRequest().then(() => {
            this.queryParamsRequest(extendParamGroupId).then(() => {
              this.$message.success('创建成功')
            })
          })
        })
      } else {
        groupInfo.isEdit = false
        this.updateParamGroupRequest(groupInfo).then(() => {
          this.queryParamGroupRequest().then(() => {
            this.$message.success('更新成功')
          })
        })
      }
    },
    cancelEditGroupName(groupInfo) {
      groupInfo.isEdit = false
      let findIndex = this.paramGroupList.findIndex(
        item => item.extendParamGroupId == groupInfo.extendParamGroupId
      )
      if (groupInfo.isNewAdd) {
        this.paramGroupList.splice(findIndex, 1)
      } else {
        let groupOriginInfo = this.paramGroupList[findIndex]
        let originGroupName = groupOriginInfo.originGroupName
        this.$set(groupInfo, 'extendParamGroupName', originGroupName)
      }
    },
    reNameGroup(groupInfo) {
      let isExistEditingGroup = this.paramGroupList.some(el => el.isEdit)
      if (isExistEditingGroup) {
        this.$message.warning('请先保存当前正在编辑的属性分组')
        return
      }

      let isExistEditingParam = this.paramsList.some(el => el.isEdit)
      if (isExistEditingParam) {
        this.$message.warning('请先保存当前正在编辑的属性')
        return
      }

      this.$set(groupInfo, 'isEdit', true)
    },
    deleteGroup(groupInfo) {
      let isExistEditingGroup = this.paramGroupList.some(el => el.isEdit)
      if (isExistEditingGroup) {
        this.$message.warning('请先保存当前正在编辑的属性分组')
        return
      }

      let isExistEditingParam = this.paramsList.some(el => el.isEdit)
      if (isExistEditingParam) {
        this.$message.warning('请先保存当前正在编辑的属性')
        return
      }

      // prettier-ignore
      let warningMsg = "删除此属性分组后，其下的所有属性也将被一并移除。您确定要继续吗？";
      this.$confirm(warningMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteParamGroupRequest(groupInfo).then(() => {
            this.queryParamGroupRequest().then(() => {
              if (this.paramGroupList.length) {
                // prettier-ignore
                let extendParamGroupId = this.paramGroupList[0].extendParamGroupId;
                this.currSelectedGroupId = extendParamGroupId
                this.queryParamsRequest(extendParamGroupId).then(() => {
                  this.$message.success('删除成功')
                })
              } else {
                this.paramsList = []
                this.$message.success('删除成功')
              }
            })
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    handleGroupClick(groupInfo) {
      let extendParamGroupId = groupInfo.extendParamGroupId
      this.currSelectedGroupId = extendParamGroupId
      this.queryParamsRequest(extendParamGroupId)
    },
    addParam() {
      let isExistEditingGroup = this.paramsList.some(el => el.isEdit)
      if (isExistEditingGroup) {
        this.$message.warning('请先保存当前正在编辑的属性分组')
        return
      }

      let isExistEditingParam = this.paramsList.some(el => el.isEdit)
      if (isExistEditingParam) {
        this.$message.warning('请先保存当前正在编辑的属性')
        return
      }

      let tempParam = {
        extendParamId: -1,
        extendParamName: '',
        extendParamValue: '',
        extendParamType: '',
        isNewAdd: true,
        isEdit: true
      }
      this.paramsList.push(tempParam)
    },
    editParam(param, field, value) {
      this.$set(param, field, value)
    },
    saveParam(paramInfo) {
      if (paramInfo.isNewAdd) {
        this.createParamRequest(paramInfo).then(() => {
          let extendParamGroupId = this.currSelectedGroupId
          this.queryParamsRequest(extendParamGroupId).then(() => {
            this.$message.success('创建属性成功')
          })
        })
      } else {
        paramInfo.isEdit = false
        this.updateParamRequest(paramInfo).then(() => {
          this.$message.success('更新成功')
        })
      }
    },
    cancelEditParam(paramInfo) {
      paramInfo.isEdit = false
      let findIndex = this.paramsList.findIndex(
        item => item.extendParamId == paramInfo.extendParamId
      )
      if (paramInfo.isNewAdd) {
        this.paramsList.splice(findIndex, 1)
      } else {
        let paramOriginInfo = this.paramsList[findIndex]
        let originParamName = paramOriginInfo.originParamName
        let originParamValue = paramOriginInfo.originParamValue
        let originParamType = paramOriginInfo.originParamType
        this.$set(paramInfo, 'extendParamName', originParamName)
        this.$set(paramInfo, 'extendParamValue', originParamValue)
        this.$set(paramInfo, 'extendParamType', originParamType)
      }
    },
    enableParamEdit(paramInfo) {
      let isExistEditingGroup = this.paramGroupList.some(el => el.isEdit)
      if (isExistEditingGroup) {
        this.$message.warning('请先保存当前正在编辑的属性分组')
        return
      }

      let isExistEditingParam = this.paramsList.some(el => el.isEdit)
      if (isExistEditingParam) {
        this.$message.warning('请先保存当前正在编辑的属性')
        return
      }

      this.$set(paramInfo, 'isEdit', true)
    },
    deleteParam(paramInfo) {
      let isExistEditingGroup = this.paramGroupList.some(el => el.isEdit)
      if (isExistEditingGroup) {
        this.$message.warning('请先保存当前正在编辑的属性分组')
        return
      }

      let isExistEditingParam = this.paramsList.some(el => el.isEdit)
      if (isExistEditingParam) {
        this.$message.warning('请先保存当前正在编辑的属性')
        return
      }

      let warningMsg = '您确定要删除当前属性吗？'
      this.$confirm(warningMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.deleteParamRequest(paramInfo).then(() => {
            let extendParamGroupId = this.currSelectedGroupId
            this.queryParamsRequest(extendParamGroupId).then(() => {
              this.$message.success('删除成功')
            })
          })
        })
        .catch(() => {
          // this.$message.info('取消删除')
        })
    },
    queryParamGroupRequest() {
      return new Promise(resolve => {
        let { dataSetId, elemId } = this.elemInfo
        let params = { dataSetId, elementIntId: elemId }
        getExtendParamGroupListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            data.forEach(item => {
              item.originGroupName = item.extendParamGroupName
            })
            this.paramGroupList = data
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    createParamGroupRequest(groupInfo) {
      return new Promise(resolve => {
        let { dataSetId, elemId } = this.elemInfo
        let params = {
          dataSetId,
          elementIntId: elemId,
          extendParamGroupName: groupInfo.extendParamGroupName
        }
        createExtendParamGroupService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve(data)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    updateParamGroupRequest(groupInfo) {
      return new Promise(resolve => {
        let { dataSetId, elemId } = this.elemInfo
        let params = {
          dataSetId,
          elementIntId: elemId,
          extendParamGroupId: groupInfo.extendParamGroupId,
          extendParamGroupName: groupInfo.extendParamGroupName
        }
        updateExtendParamGroupService(params).then(response => {
          if (response.isSuccess) {
            resolve()
          } else {
            this.$message.error(response.errMsg)
            this.cancelEditGroupName(groupInfo)
          }
        })
      })
    },
    deleteParamGroupRequest(groupInfo) {
      return new Promise(resolve => {
        let { dataSetId } = this.elemInfo
        let params = {
          dataSetId,
          extendParamGroupId: groupInfo.extendParamGroupId
        }
        deleteExtendParamGroupService(params).then(response => {
          if (response.isSuccess) {
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    deleteGroupRequest(groupInfo) {
      return new Promise(resolve => {
        let { dataSetId, elemId } = this.elemInfo
        let params = {
          dataSetId,
          elementIntId: elemId,
          extendParamGroupId: groupInfo.extendParamGroupId
        }
        deleteExtendParamByGroupService(params).then(response => {
          if (response.isSuccess) {
            let delGroupParams = {
              dataSetId,
              extendParamGroupId: groupInfo.extendParamGroupId
            }
            deleteExtendParamGroupService(delGroupParams).then(res => {
              if (res.isSuccess) {
                resolve()
              } else {
                this.$message.error(res.errMsg)
              }
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    queryParamsRequest(extendParamGroupId) {
      return new Promise(resolve => {
        let { dataSetId, elemId } = this.elemInfo
        let params = { dataSetId, elementIntId: elemId, extendParamGroupId }
        getExtendParamsService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data

            if (data.length) {
              let paramInfo = data[0]
              let paramsData = paramInfo.data
              paramsData.forEach(item => {
                item.originParamName = item.extendParamName
                item.originParamValue = item.extendParamValue
                item.originParamType = item.extendParamType
              })
              this.paramsList = paramsData
            } else {
              this.paramsList = []
            }

            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    createParamRequest(paramInfo) {
      return new Promise(resolve => {
        let { dataSetId, elemId } = this.elemInfo
        let params = {
          dataSetId,
          extendParams: [
            {
              elementIntId: elemId,
              extendParamName: paramInfo.extendParamName,
              extendParamValue: paramInfo.extendParamValue,
              extendParamGroupId: this.currSelectedGroupId,
              extendParamType: paramInfo.extendParamType
            }
          ]
        }
        createExtendParamService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve(data)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    updateParamRequest(paramInfo) {
      return new Promise(resolve => {
        let { dataSetId, elemId } = this.elemInfo
        let param = {
          dataSetId,
          extendParam: {
            extendParamId: paramInfo.extendParamId,
            elementIntId: elemId,
            extendParamName: paramInfo.extendParamName,
            extendParamValue: paramInfo.extendParamValue,
            extendParamGroupId: this.currSelectedGroupId,
            extendParamType: paramInfo.extendParamType
          }
        }
        updateExtendParamService(param).then(response => {
          if (response.isSuccess) {
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    deleteParamRequest(paramInfo) {
      return new Promise(resolve => {
        let { dataSetId, elemId } = this.elemInfo
        let params = {
          dataSetId,
          elementIntId: elemId,
          extendParamGroupId: this.currSelectedGroupId,
          extendParamId: paramInfo.extendParamId
        }
        deleteExtendParamByIdService(params).then(response => {
          if (response.isSuccess) {
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    clearData() {
      this.paramGroupList = []
      this.currSelectedGroupId = ''
      this.paramsList = []
    },
    isGroupActive(groupInfo) {
      return groupInfo.extendParamGroupId === this.currSelectedGroupId
    },
    isAddParamDisabled() {
      if (this.paramGroupList.length && this.currSelectedGroupId) {
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.dialog-primary) {
  height: 540px;

  .dialog-content {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);
    padding: 0px !important;
    font-size: 14px;
    background: var(--base-light-color25);

    .primary-btn {
      display: flex;
      border-radius: 4px;
    }

    .elem-info-box {
      display: flex;
      align-items: center;
      padding: 8px 16px;
      background: var(--bim-scene-add-attr-tag-bgColor);

      .item-box {
        display: flex;
        flex-shrink: 1;
        align-items: center;
        margin-right: 8px;
        padding: 0px 4px;
        color: var(--base-dark35-color);
        border-radius: 4px;
        text-align: left;
        border: 1px solid var(--base-dark35-color);
        background: var(--base-bg-light-color56);

        &:first-child {
          flex-shrink: 0;
        }

        &:last-child {
          flex-shrink: 0;
        }

        .label {
          flex-shrink: 0;
        }

        .value {
          flex-grow: 1;
        }
      }

      .elem-name-box {
        max-width: 200px;
      }
    }

    .empty-box {
      display: flex;
      height: calc(100% - 50px);
      text-align: center;

      .tip-box {
        margin: auto;
        font-size: 12px;

        .text-btn-box {
          color: var(--page-tips-text-color);
        }
      }
    }

    .extend-params-box {
      flex-grow: 1;
      display: flex;
      border-top: 1px solid var(--bim-scene-add-attr-tag-border-color);
      overflow: hidden;

      .group-box {
        display: flex;
        flex-direction: column;
        width: 240px;
        padding: 10px;
        flex-shrink: 0;

        .add-group-box {
          padding: 5px;
        }

        .group-list-box {
          flex-grow: 1;
          overflow-y: auto;

          .item-box {
            padding: 5px;
          }
        }

        .action-btn-box {
          display: flex;
        }

        .edit-group-box {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .icon-box {
            width: 20px;
            height: 20px;
            margin-left: 10px;
            border-radius: 4px;
            cursor: pointer;
            text-align: center;

            &:hover {
              background: var(--base-bg-dark-color33);
            }
          }

          .submit-btn-box {
            color: var(--base-light-color3);
          }

          .cancel-btn-box {
            color: var(--base-light-color4);
          }
        }

        .normal-group-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 6px 8px;
          border-radius: 4px;
          cursor: pointer;
          background-color: var(--tab-bgColor);
          color: var(--tab-text-color);

          .group-name {
            word-break: break-all;
          }

          &:hover {
            background: var(--base-bg-light-color77);
            .group-name {
              color: var(--base-primary-bgColor);
            }
          }

          &.active {
            background: var(--base-bg-light-color77);
            .group-name {
              color: var(--base-primary-bgColor);
            }
          }

          .icon-box {
            margin-left: 10px;
            color: var(--tab-icon-color);
            cursor: pointer;

            &:hover {
              color: var(--base-primary-bgColor);
            }
          }
        }
      }

      .split-line {
        width: 1px;
        height: 100%;
        background: var(--bim-scene-add-attr-tag-border-color);
      }

      .param-box {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        padding: 15px;
        min-width: 0;

        .primary-btn {
          width: 108px;
        }

        .table-box {
          flex-grow: 1;
          min-height: 0;
          margin-top: 10px;

          .el-table {
            background-color: transparent;
            &::before {
              display: none;
            }

            .el-table__body-wrapper {
              .el-table__row {
                .el-table__cell{
                  background-color: var(--table-bgColor);
                }
                &:hover {
                  .el-table__cell {
                    background-color: var(--table-bgColor);
                  }
                }
              }
            }
          }

          .cell-operation-btn-box {
            height: auto;
            line-height: normal;
            display: flex;
            justify-content: space-between;

            .el-button {
              border: none;
              color: var(--base-primary-bgColor);
              font-size: 14px;
              font-weight: 400;
              padding: 0;
              width: auto;
              height: auto;
              line-height: normal;
              text-align: left;

              &:hover {
                background-color: transparent !important;
                padding: 0;
                color: var(--base-primary-bgColor) !important;
                line-height: inherit;
              }
            }
          }
        }

        .empty-box {
          flex-grow: 1;
        }
      }
    }

    .operation-btn-box {
      padding: 15px;
      text-align: right;
      border-top: 1px solid var(--base-border-light-color5);
    }
  }
}
</style>
